<!--
  Vue wrapper for BryntumDemoHeader
-->

<template>
    <header class="demo-header">
        <div id="title-container">
            <a
                id    = "title"
                :href = "link"
            >{{ title }}</a>
        </div>
        <slot /><bryntum-fullscreen-button />
    </header>
</template>

<script>

import BryntumFullscreenButton from './BryntumFullscreenButton.vue';

export default {

    name : 'BryntumDemoHeader',

    components : {
        BryntumFullscreenButton
    },

    props : {
        link  : { type : String, default : '..' },
        title : { type : String, default : 'Example Header' }
    }
};

</script>
